"use client";

import React, { useState } from "react";
import Image from "next/image";
import {Container} from "@/shared/components/shared";
import {Button} from "@/shared/components/ui/button";
import UniversalBookingModal from "@/shared/components/ui/universal-booking-modal";

export const Hero: React.FC = () => {
    const [isUniversalBookingOpen, setIsUniversalBookingOpen] = useState(false);

    return (
        <>
            <section className={'relative h-auto md:h-screen'}>
                {/* Mobile: обычный Image для подстройки контейнера под изображение */}
                <div className="relative w-full md:hidden">
                    <div className="relative w-full">
                        <Image
                            src="/images/hero.jpeg"
                            alt="Главное изображение"
                            width={1920}
                            height={1080}
                            priority
                            sizes="100vw"
                            className="w-full h-auto object-contain object-top"
                        />
                        <div
                            className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-[rgba(0,24,75,0.58)] bg-[length:100%_100%] bg-[position:0_0,0_0] bg-blend-multiply"/>
                        <div className="absolute bottom-0 left-0 right-0 z-10 pb-[16px]">
                            <Container className={'mx-auto w-full'}>
                                <h2 className={'text-white font-bold text-[30px] uppercase text-center leading-none'}>
                                    Добро пожаловать на автоборт!
                                </h2>
                            </Container>
                        </div>
                    </div>
                </div>
                {/* Desktop: fill Image */}
                <div className="hidden md:block absolute top-0 left-0 right-0 bottom-0">
                    <div className="relative w-full h-full">
                        <Image
                            src="/images/hero.jpeg"
                            alt="Главное изображение"
                            fill
                            priority
                            sizes="100vw"
                            className="object-cover object-center"
                        />
                        <div
                            className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-[rgba(0,24,75,0.58)] bg-[length:100%_100%] bg-[position:0_0,0_0] bg-blend-multiply"/>
                        <div className="absolute inset-0 z-10 flex items-end pb-[16px] lg:pb-[44px]">
                            <Container className={'mx-auto w-full'}>
                                <h2 className={'text-white font-bold text-[30px] lg:text-[70px] uppercase text-center leading-none'}>
                                    Добро пожаловать на автоборт!
                                </h2>
                            </Container>
                        </div>
                    </div>
                </div>
            </section>
            <section className={'pt-6 md:pt-10 lg:pt-16 pb-15 lg:pb-30'}>
                <Container className={'flex flex-col'}>
                    <h2 className={'font-bold text-custom-gray text-[30px] lg:text-[70px] uppercase text-center leading-none'}>
                        Первой Современной Станции <br className={'block lg:hidden'}/>
                        <span className={'text-custom-orange'}>ЭКСПРЕСС-УСЛУГ F1</span>
                    </h2>
                    <div className={`mt-8 md:mt-10 lg:mt-16 lg:self-center`}>
                        <Button 
                            className={`w-full py-3 lg:py-4 lg:px-25 font-button lg:self-center`}
                            onClick={() => setIsUniversalBookingOpen(true)}
                        >
                            познакомиться поближе
                        </Button>
                    </div>
                </Container>
            </section>
            <UniversalBookingModal isOpen={isUniversalBookingOpen} onClose={() => setIsUniversalBookingOpen(false)} blockName="Главная страница - Первой Современной Станции"/>
        </>
    )
}